/**
 * Shared Add to cart loading for Rebuy widget / bundle buttons.
 * Theme product forms are handled in cart.js; this keeps Rebuy in sync.
 */

const ANNOUNCE_DELAY_MS = 50;
const ATC_LOADER_MS = 4000;

const REBUY_ATC_SELECTOR = [
  '.rebuy-widget .rebuy-button',
  '.rebuy-bundle .rebuy-button',
  '.rebuy-bundle-builder button.rebuy-button',
].join(', ');

const REBUY_DONE_EVENTS = [
  'rebuy.add',
  'rebuy.error',
  'rebuy:cart.add',
  'rebuy:cart.error',
  'cart:change',
  'cart:error',
];

const loadingButtons = new Set();
let loadingTimeoutId = 0;
let announceTimerId = 0;

function config() {
  return document.getElementById('AtcLoadingConfig');
}

function statusRegion() {
  return document.getElementById('AtcLoadingStatus');
}

function isRebuyAtc(button) {
  if (!(button instanceof HTMLElement)) return false;
  if (!button.matches(REBUY_ATC_SELECTOR)) return false;
  if (button.closest('.rebuy-cart')) return false;
  if (button.classList.contains('rebuy-cart__checkout-button')) return false;
  if (button.classList.contains('secondary')) return false;
  if (button.classList.contains('outline')) return false;
  if (button.classList.contains('rebuy-bundle-builder__product-quick-view')) return false;
  return true;
}

function announce(text) {
  const region = statusRegion();
  if (!region || !text) return;
  region.textContent = '';
  requestAnimationFrame(() => {
    clearTimeout(announceTimerId);
    announceTimerId = window.setTimeout(() => {
      region.textContent = text;
    }, ANNOUNCE_DELAY_MS);
  });
}

function setRebuyLoading(button, loading) {
  if (!(button instanceof HTMLElement)) return;

  if (loading) {
    loadingButtons.add(button);
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
  } else {
    loadingButtons.delete(button);
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
  }
}

function clearAllRebuyLoading(announceAdded) {
  clearTimeout(loadingTimeoutId);
  loadingTimeoutId = 0;
  loadingButtons.forEach((button) => setRebuyLoading(button, false));
  loadingButtons.clear();
  if (announceAdded) {
    announce(config()?.dataset.addedLabel || '');
  }
}

function startRebuyLoading(button) {
  setRebuyLoading(button, true);
  announce(config()?.dataset.loadingLabel || '');
  clearTimeout(loadingTimeoutId);
  loadingTimeoutId = window.setTimeout(() => {
    clearAllRebuyLoading(true);
  }, ATC_LOADER_MS);
}

document.addEventListener(
  'click',
  (event) => {
    const button = event.target instanceof Element ? event.target.closest(REBUY_ATC_SELECTOR) : null;
    if (!button || !isRebuyAtc(button)) return;
    if (button.getAttribute('aria-busy') === 'true') return;
    startRebuyLoading(button);
  },
  true
);

REBUY_DONE_EVENTS.forEach((eventName) => {
  document.addEventListener(eventName, () => {
    if (!loadingButtons.size) return;
    if (eventName === 'rebuy.error' || eventName === 'rebuy:cart.error' || eventName === 'cart:error') {
      clearAllRebuyLoading(false);
    }
  });
});

function bindRebuyApi() {
  const rebuy = window.Rebuy;
  if (!rebuy?.on || bindRebuyApi.bound) return;
  bindRebuyApi.bound = true;
  rebuy.on('cart.add', () => clearAllRebuyLoading(true));
  rebuy.on('cart.error', () => clearAllRebuyLoading(false));
}

bindRebuyApi();
document.addEventListener('rebuy.ready', bindRebuyApi);
window.setTimeout(bindRebuyApi, 2000);
